import { z } from 'zod';

/**
 * @aiPurpose content-free invalidation for the Cargo Problem workspace.
 * @aiInvariant reconnect/focus re-reads REST; this payload carries only the
 *   parent id and the cache family that changed.
 * @aiSecurity the backend intersects the internal recipient allowlist with
 *   live `cargoProblems.read` and parent visibility on every socket emit.
 * @aiPii no message text, file metadata, actor identity, reason, public code,
 *   or Cargo projection may cross this channel.
 */
export const CARGO_PROBLEM_WORKSPACE_UPDATED = 'cargo-problem-workspace:updated' as const;
export const CargoProblemWorkspaceUpdatedKindSchema = z.enum([
  'message',
  'workflow',
  'material',
  'read',
]);
export const CargoProblemWorkspaceUpdatedEventSchema = z
  .object({
    problemId: z.string().uuid(),
    kind: CargoProblemWorkspaceUpdatedKindSchema,
  })
  .strict();
export type CargoProblemWorkspaceUpdatedEvent = z.infer<
  typeof CargoProblemWorkspaceUpdatedEventSchema
>;
